/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
import { Injectable } from "@angular/core";
import { getBrowserCultureLang } from "@html-core";
import { HorizonClientInfo } from "../../../shared/common/service/client-info.service";
import { useragentUtil, ClientOS } from "../../../core/libs/useragent-util";
/* cSpell:disable */
export enum HostOS {
   WIN32 = "WIN32",
   WIN64 = "WIN64",
   LINUX64 = "LINUX64",
   LINUX32 = "LINUX32",
   ANDROID = "ANDROID",
   IOS = "IOS",
   CHROMEOS = "CHROMEOS",
   MAC = "MAC",
   UNKNOWN = "UNKNOWN"
}

@Injectable({
   providedIn: "root"
})
export class HTML5ClientInfoServiceV2 {
   private clientInfo: HorizonClientInfo = null as HorizonClientInfo;
   constructor() {}
   public getHostOS = async (): Promise<string> => {
      let os: HostOS = HostOS.UNKNOWN;
      const _os: string = useragentUtil.getHostOS();
      if (_os == ClientOS.WINDOWS) {
         let b = await useragentUtil.getOSBitness();
         if (b == "64") {
            os = HostOS.WIN64;
         } else {
            os = HostOS.WIN32;
         }
      } else if (_os == ClientOS.ANDROID) {
         os = HostOS.ANDROID;
      } else if (_os == ClientOS.LINUX) {
         let b = await useragentUtil.getOSBitness();
         if (b == "64") {
            os = HostOS.LINUX64;
         } else {
            os = HostOS.LINUX32;
         }
      } else if (_os == ClientOS.IOS) {
         os = HostOS.IOS;
      } else if (_os == ClientOS.CHROMEOS) {
         os = HostOS.CHROMEOS;
      } else if (_os == ClientOS.MAC) {
         os = HostOS.MAC;
      }
      return os;
   };

   public getClientInfo = async (): Promise<HorizonClientInfo> => {
      if (!this.clientInfo) {
         this.clientInfo = {} as HorizonClientInfo;
         this.clientInfo.acceptLanguage = getBrowserCultureLang();
         this.clientInfo.clientVersion = __VDM_WEB_CLIENT_VERSION__ || "8.17.0";
         this.clientInfo.os = (await this.getHostOS()).toString().toLowerCase();
      }
      return this.clientInfo;
   };
}
